import React, { useState, useEffect } from 'react';
import { CardComponentProps } from '@/lib/cards';

/**
 * Account Status Card
 * Displays user account status and account-related information
 */
export const AccountStatusCard: React.FC<CardComponentProps> = ({
  card,
  userContext,
  onError,
}) => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadData() {
      try {
        setLoading(true);
        const mockData = {
          accountStatus: 'active',
          emailVerified: true,
          mfaEnabled: true,
          passwordLastChanged: '2025-11-20',
          loginAttempts: 0,
          accountLocked: false,
        };
        setData(mockData);
      } catch (err) {
        onError?.(err instanceof Error ? err : new Error(String(err)));
      } finally {
        setLoading(false);
      }
    }

    loadData();
  }, [onError]);

  if (loading) return <div style={{ padding: '1rem', color: '#666' }}>Loading...</div>;
  if (!data) return null;

  return (
    <div style={{ padding: '1rem' }}>
      <div style={{ display: 'grid', gap: '0.75rem' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <strong>Account Status:</strong>
          <span
            style={{
              padding: '0.25rem 0.75rem',
              backgroundColor: data.accountStatus === 'active' ? '#28a745' : '#dc3545',
              color: 'white',
              borderRadius: '3px',
              fontSize: '0.85rem',
            }}
          >
            {data.accountStatus}
          </span>
        </div>
        <div>
          <strong>Email Verified:</strong> {data.emailVerified ? '✓ Yes' : '✗ No'}
        </div>
        <div>
          <strong>MFA Enabled:</strong> {data.mfaEnabled ? '✓ Yes' : '✗ No'}
        </div>
        <div>
          <strong>Password Last Changed:</strong> {new Date(data.passwordLastChanged).toLocaleDateString()}
        </div>
        <div>
          <strong>Account Locked:</strong> {data.accountLocked ? '✓ Locked' : '✗ Not locked'}
        </div>
      </div>
    </div>
  );
};

AccountStatusCard.displayName = 'AccountStatusCard';

export default AccountStatusCard;
